import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidthMobile?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  fullWidthMobile = true,
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-5 text-base sm:text-lg' : 'px-9 py-4 text-sm sm:text-base';
  return <a href={href} className={['group inline-flex items-center justify-center gap-2 rounded-full bg-forest font-semibold tracking-tight text-white', 'shadow-card transition-[transform,box-shadow,background-color] duration-200 ease-smooth', 'hover:-translate-y-0.5 hover:bg-forest-dark hover:shadow-lift', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold', fullWidthMobile ? 'w-full sm:w-auto' : '', sizing, className].join(' ')} data-id="element-418" data-mp="1m3uvxtp7tzjc">
      <span data-id="element-419" data-mp="184liv2wb3ljl">{children}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-420" data-mp="184vaeux020re" />
    </a>;
}